import React from 'react';
import { ShowIf} from 'components/utils';
import { Text } from 'components/tt-forms/common';
import DoiTuongKienNghi from './DoiTuongKienNghi.jsx';
import {RowItemDoiTuongThanhTra, RowItemDoiTuongThanhTraView} from 'modules/thanh-tra/datatable';
import {Dialog} from "@blueprintjs/core";
import { header } from 'constants/table';
import {ThanhTra} from 'api';
import { Toastr } from 'modules/toastr';
import DataTable from 'components/data-table';
import { msg } from 'constants/message';
import {ConfirmDialog} from 'modules/dialog';

class NoiDungKienNghi extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,

      backConfirm: false,
      hasChange: false,

      type: this.props.type,
      id: this.props.id,
      idEdit: '',
      editDialogTitle: '',
      tongToChucKienNghiXuLyHanhChinh: 0,
      tongCaNhanKienNghiXuLyHanhChinh: 0,
      tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
      tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
      tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
      tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
      tongSaiPhamVeTienKienNghiXuLyKhac: 0,
      tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0,
      listDoiTuongThanhTra: this.props.listDoiTuongThanhTra,
      dataDoiTuongViPham: [],
    }
  }

  componentDidMount() {
    this.getListDaTa();
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  getListDaTa() {
    let params = {
      cuocThanhTraId: this.state.id
    }
    if (this.props.view) {
      params.loaiDoiTuongTheoDoi = 'DOI_TUONG_THEO_DOI'
    }
    ThanhTra.actions.getDoiTuongViPham.request(params).then(res => {
      if(res.data._embedded) {
        this.setState({
          dataDoiTuongViPham: res.data._embedded.doiTuongViPhams
        },() => {
          this.checkSum();
          this.setCountDoiTuongViPham();
          this.setDoiTuongViPhamHienTai();
        })
      } else {
        this.setState({
          dataDoiTuongViPham: []
        },() => {
          this.checkSum();
          this.setCountDoiTuongViPham();
          this.setDoiTuongViPhamHienTai();
        })
      }
    })
  }

  clearDataContain(name) {
    let data = [...this.state.dataDoiTuongViPham];
    let dataFilter = data.filter(item => {
      return name == item.ten
    })

    if(dataFilter.length > 0) {
      let params = {doiTuongViPhams: []}
      dataFilter.map(item => {
        params.doiTuongViPhams[params.doiTuongViPhams.length] = {
          id: item.doiTuongViPhamId
        }
      })
      ThanhTra.actions.deleteDoiTuongViPham.request('',params).then(res => {
        Toastr('Xóa đối tượng vi phạm thành công', 'success');
        this.getListDaTa();
      });
    } else {
      Toastr('Dữ liệu không tồn tại', 'error');
    }
  }

  setDoiTuongViPhamHienTai() {
    this.props.setDoiTuongViPhamHienTai(this.state.dataDoiTuongViPham);
  }

  setCountDoiTuongViPham() {
    this.props.setCountDoiTuongViPham(this.state.dataDoiTuongViPham.length);
  }

  resetData() {
    let params = {doiTuongViPhams: []}
    this.state.dataDoiTuongViPham.map(item => {
      params.doiTuongViPhams[params.doiTuongViPhams.length] = {
        id: item.doiTuongViPhamId
      }
    })
    ThanhTra.actions.deleteDoiTuongViPham.request('',params).then(res => {
      Toastr('Xóa tất cả đối tượng vi phạm thành công', 'success');
      this.getListDaTa();
    });
  }

  clearData() {
    let params = {
      doiTuongViPhams: []
    };
    this.state.dataDoiTuongViPham.map(item => {
      params.doiTuongViPhams[params.doiTuongViPhams.length] = {
        id: item.doiTuongViPhamId
      }
    })
    ThanhTra.actions.deleteDoiTuongViPham.request('',params);
  }

  checkSum() {
    if (this.state.dataDoiTuongViPham.length > 0) {
      let tongToChucKienNghiXuLyHanhChinh = 0;
      let tongCaNhanKienNghiXuLyHanhChinh = 0;
      let tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
      let tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
      let tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
      let tongSaiPhamVeTienKienNghiXuLyKhac = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
      this.state.dataDoiTuongViPham.map(item => {
        let toChucCoSaiPham = item.toChucCoSaiPham;
        let dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
        if(dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
          tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length
        }
        let caNhanCoSaiPham = item.caNhanCoSaiPham;
        let dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
        if(dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
          tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length
        }
        tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecKienNghiChuyenCoQuanDieuTra;
        tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.tienKienNghiXuLyKhac;
        tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.datKienNghiXuLyKhac;
        tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + item.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeTienKienNghiKhacXuLyVeKinhTe;
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeDatKienNghiKhacXuLyVeKinhTe;
        if(item.chuyenCoQuanDieuTra) {
          tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + 1;
        }
      })
      this.setState({
        tongToChucKienNghiXuLyHanhChinh: tongToChucKienNghiXuLyHanhChinh,
        tongCaNhanKienNghiXuLyHanhChinh: tongCaNhanKienNghiXuLyHanhChinh,
        tongSaiPhamVeTienKienNghiXuLyKinhTe: tongSaiPhamVeTienKienNghiXuLyKinhTe,
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: tongSaiPhamVeDatDaiKienNghiXuLyKinhTe,
        tongVuViecKienNghiChuyenCoQuanDieuTra: tongVuViecKienNghiChuyenCoQuanDieuTra,
        tongDoiTuongKienNghiChuyenCoQuanDieuTra: tongDoiTuongKienNghiChuyenCoQuanDieuTra,
        tongSaiPhamVeTienKienNghiXuLyKhac: tongSaiPhamVeTienKienNghiXuLyKhac,
        tongSaiPhamVeDatDaiKienNghiXuLyKhac: tongSaiPhamVeDatDaiKienNghiXuLyKhac,
      })
    } else {
      this.setState({
        tongToChucKienNghiXuLyHanhChinh: 0,
        tongCaNhanKienNghiXuLyHanhChinh: 0,
        tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
        tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
        tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
        tongSaiPhamVeTienKienNghiXuLyKhac: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.type != nextProps.type) {
      this.setState({
        type: nextProps.type
      })
    }
  }

  handleEditDoiTuongKienNghi(id) {
    this.setState({
      idEdit: id,
      editDialogTitle: 'Chỉnh sửa đối tượng vi phạm'
    },()=> {
      this.setState({
        isOpen: true
      })
    })
  }

  handleAddMore() {
    this.setState({
      idEdit: null,
      editDialogTitle: 'Thêm mới đối tượng vi phạm'
    },()=> {
      this.setState({
        isOpen: true
      })
    })
  }

  handleDelete(sID) {
    let params = {
      doiTuongViPhams: [
        {
          id: sID
        }
      ]
    }
    ThanhTra.actions.deleteDoiTuongViPham.request('',params).then(res => {
      Toastr('Xóa đối tượng vi phạm thành công', 'success');
      this.getListDaTa();
    });
  }

  handleBack(allowBack) {
    if (allowBack == true) {
      this.setState({
        isOpen: false,
        backConfirm: false,
        hasChange: false
      })
      this.DoiTuongKienNghi.resetData();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        this.setState({
          isOpen: false,
          backConfirm: false,
          hasChange: false
        })
        this.DoiTuongKienNghi.resetData();
      }
    }
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  getTitleDanhSach() {
    let titleDanhSach = "";
    if (this.props.isTTTW) {
      if (this.state.type === 'KE_HOACH') {
        titleDanhSach = '5.1 Danh sách đối tượng vi phạm';
      } else {
        titleDanhSach = '4.1 Danh sách đối tượng vi phạm';
      }
    } else {
      if (this.state.type === 'KE_HOACH') {
        titleDanhSach = '4.1 Danh sách đối tượng vi phạm';
      } else {
        titleDanhSach = '3.1 Danh sách đối tượng vi phạm';
      }
    }
    return titleDanhSach;
  }

  render() {
    return (
      <div className="row pl10 pr10">
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="col-50 no-gutter clear-left mb10">
          <p className="txt-bold txt-upper mb10 pl5 pr5">Tổng vi phạm</p>
          <Text className="col-100" label="Số đơn vị vi phạm/đơn vị liên quan:" value={this.state.dataDoiTuongViPham.length + '/' + this.props.listDoiTuongViPham.length}/>
        </div>
        <div className="col-50 no-gutter mb10">
          <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý hành chính</p>
          <Text className="col-50" label="Tổng tổ chức:" value={this.state.tongToChucKienNghiXuLyHanhChinh ? String(this.state.tongToChucKienNghiXuLyHanhChinh) : '0'}/>
          <Text className="col-50" label="Tổng cá nhân:" value={this.state.tongCaNhanKienNghiXuLyHanhChinh ? String(this.state.tongCaNhanKienNghiXuLyHanhChinh) : '0'}/>
        </div>
        <div className="col-50 no-gutter clear-left mb10">
          <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý kinh tế</p>
          <Text className="col-50" label="Sai phạm về tiền (đ):" value={this.state.tongSaiPhamVeTienKienNghiXuLyKinhTe ? String(this.state.tongSaiPhamVeTienKienNghiXuLyKinhTe) : '0'}/>
          <Text className="col-50" label="Sai phạm về đất đai (m2):" value={this.state.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe ? String(this.state.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe) : '0'}/>
        </div>
        <div className="col-50 no-gutter mb10">
          <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị chuyển cơ quan điều tra</p>
          <Text className="col-50" label="Số vụ việc:" value={this.state.tongVuViecKienNghiChuyenCoQuanDieuTra ? String(this.state.tongVuViecKienNghiChuyenCoQuanDieuTra) : '0'}/>
          <Text className="col-50" label="Đối tượng:" value={this.state.tongDoiTuongKienNghiChuyenCoQuanDieuTra ? String(this.state.tongDoiTuongKienNghiChuyenCoQuanDieuTra) : '0'}/>
        </div>
        <div className="col-50 no-gutter clear-left mb10">
          <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý khác</p>
          <Text className="col-50" label="Sai phạm về tiền (đ):" value={this.state.tongSaiPhamVeTienKienNghiXuLyKhac ? String(this.state.tongSaiPhamVeTienKienNghiXuLyKhac) : '0'}/>
          <Text className="col-50" label="Sai phạm về đất đai (m2):" value={this.state.tongSaiPhamVeDatDaiKienNghiXuLyKhac ? String(this.state.tongSaiPhamVeDatDaiKienNghiXuLyKhac) : '0'}/>
        </div>
        <div className='col-100'>
          <div className='line-border mb15'></div>
          <h2 className='title-12'>{this.getTitleDanhSach()}</h2>
        </div>
        <ShowIf condition={this.props.view != true}>
          <div className='col-100 no-gutter'>
            <div className='row white-table'>
              <DataTable
                header={header.thanhTra.danhSachDoiTuongViPham}
                dataList={this.state.dataDoiTuongViPham}
                pageData={this.state.pageData}
                parent={this}
                hideButtonExport
                titleAddmore='Thêm mới đối tượng vi phạm'
                hidePagination={true}
                addMore={this.handleAddMore.bind(this)}
                showAddMore={true}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                  <RowItemDoiTuongThanhTra handleEdit={this.handleEditDoiTuongKienNghi.bind(this)}/>
              </DataTable>
            </div>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.view == true}>
          <div className='col-100 no-gutter'>
            <div className='row white-table'>
              <DataTable
                header={header.thanhTra.danhSachDoiTuongViPhamView}
                dataList={this.state.dataDoiTuongViPham}
                pageData={this.state.pageData}
                parent={this}
                hideButtonExport
                hidePagination={true}
                showAddMore={false}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                  <RowItemDoiTuongThanhTraView chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} linhVucThanhTra={this.props.linhVucThanhTra}/>
              </DataTable>
            </div>
          </div>
        </ShowIf>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.handleBack.bind(this)}
          title={this.state.editDialogTitle}
          className="dialog-default wrap-block">
            <DoiTuongKienNghi doiTuongThanhTraLienQuan={this.props.doiTuongThanhTraLienQuan} onRef={DoiTuongKienNghi => (this.DoiTuongKienNghi = DoiTuongKienNghi)} handleChangeData={this.handleChangeData.bind(this)} id={this.state.idEdit} getListDaTa={this.getListDaTa.bind(this)} chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} idCuocThanhTra={this.props.id} listDoiTuongViPham={this.props.listDoiTuongViPham} closeDialog={this.handleBack.bind(this)} linhVucThanhTra={this.props.linhVucThanhTra}/>
        </Dialog>
      </div>
    );
  }
}

NoiDungKienNghi.defaultProps = {
  listDoiTuongThanhTra: [],
  listDoiTuongViPham: [],
  dataDoiTuongViPham: [],
  setDoiTuongViPhamHienTai: function() {
  },
  view: false,
  setCountDoiTuongViPham: function() {}
}

export default NoiDungKienNghi;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/NoiDungKienNghi.jsx